export class Contatos {
  id?: number;
  numeroCartao?: string;
  nome?: string;
  telefone?: string;

  constructor(data?) {
    if (data) {
      this.id = data.id;
      this.numeroCartao = data.numeroCartao;
      this.nome = data.nome;
      this.telefone = data.telefone;
    }
  }

  public static fromDTO?(data) {
    const prof = new Contatos();
    prof.id = data.id;
    prof.numeroCartao = data.numeroCartao;
    prof.nome = data.nome;
    prof.telefone = data.telefone;
    return prof;
  }

  public toDTO?() {
    const dto: any = {};
    dto.id = this.id;
    dto.numeroCartao = this.numeroCartao;
    dto.nome = this.nome;
    dto.telefone = this.telefone;
    return dto;
  }

}
